import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeApiModule } from 'api/api.module';
import { EvseApiService } from '@kempoweroyj/ngx-evse-api-client';
import { HasCapabilityCategoryPipe, StationCapabilitiesPipe } from './station-capabilities.pipe';

@NgModule({
    declarations: [StationCapabilitiesPipe, HasCapabilityCategoryPipe],
    imports: [CommonModule, CeApiModule],
    exports: [StationCapabilitiesPipe, HasCapabilityCategoryPipe],
    providers: [EvseApiService],
})
export class StationsServiceModule {}
